import { Data } from './types';
// import { PlainObject, setUserData } from '@sgorg/game-backend-client';
// import { getUserData } from '../backend/backend';
import { App } from '../app'

export const initialUserData: Data = {
    // existing start
    all_chests: '[0, 0, 0, 0, 0, 0, 0, 0, 0, 0]',
    all_friends_invite: '[]',
    all_stars: 0,
    backcards: '[2,2,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]',
    backcards_select: 'backcard_1.png',
    baloonDate: 0,
    baloonDate_new: 0,
    baloonlevel: 1,
    booster_eye_col: 0,
    booster_shuffle_col: 0,
    booster_timestop_col: 0,
    booster_tnt_col: 0,
    botopt: 1,
    bought: 0,
    builds_timer: '[]',
    builds_timer_obj: '[]',
    builds_timer_time: '[]',
    complete_task_i: -1,
    currencies: 0,
    dailyday: 0,
    dailyday_current: 0,
    dailyday_new: 0,
    dailyday_prize: '[0, 0, 0, 0, 0, 0, 0]',
    day_prize: '[0, 0, 0, 0, 0, 0]',
    dialog_mas: '[]',
    fff: 0,
    first_helper: 1,
    first_start: 1,
    free_cardback: 0,
    free_joker: 3,
    free_three: 0,
    FriendPrizeDate: 0,
    friends_invite: '[]',
    FTUE: 0,
    FTUEEVENTS: '[]',
    GiftDate: 0,
    gift_mas: '[]',
    KeyMissionPrize: 0,
    keys: 0,
    key_mission_time: new Date().toISOString(),
    last_position: '[1010, 1800]',
    level_star: '[]',
    lifes: '5',
    lifetime: new Date().toISOString(),
    life_time: 0,
    map_n: 1,
    map_tiled_st: '[]',
    message_id: '[]',
    missions: '[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]',
    mission_day_end: 0,
    mission_number: '[]',
    mission_stars_end: 0,
    mission_task: '[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]',
    mission_time: 0,
    new_roof: 2,
    new_walls: 2,
    OfferDate: 0,
    ReferralDate: 0,
    shop_free: 1,
    shop_time: 0,
    special_object: '[]',
    starter_kit: 0,
    suitcase_add: 0,
    unlimited_lifesDate: 0,
    wheelshopDate: 0,
    wheel_ads: 0,
    wheel_max: 3,
    wheel_num: 1,
    wheel_time: 0,
    music_on: 1,
    sound_on: 1,
    // existing end

    // ddna start
    sessionId: 0,
    coinsSpentImprovingGarden: 0,
    starsUsed: 0,
    gardenImprovements: 0,
    interactedFriends: [],
    // ddna end
};

export class Store {
    private mData: Data = { ...initialUserData };
    private app: App;

    constructor(app: App) {
        this.app = app;
    }

    public async init(): Promise<void> {
        const data = initialUserData;

        for (let key in data) {
            if (data[key] !== void 0 && data[key] !== null) {
                this.mData[key] = data[key];
            }
        }

        this.fixDataValues();
    }

    private fixDataValues(): void {
        const numberKeys: (keyof Data)[] = [
            'booster_shuffle_col',
            'booster_eye_col',
            'booster_tnt_col',
            'free_joker',
            'free_cardback',
            'currencies',
            'free_three',
            'all_stars',
            'mission_day_end',
        ];

        const stringKeys: (keyof Data)[] = ['lifes'];

        const fixNumberLikeValue = (key: string, Type: typeof Number | typeof String): void => {
            let n = Number(this.mData[key]);

            if (Number.isNaN(n)) {
                n = Number(initialUserData[key]);
            }

            // @ts-ignore
            this.mData[key] = Type(n);
        };

        numberKeys.forEach((key) => {
            fixNumberLikeValue(key, Number);
        });

        stringKeys.forEach((key) => {
            fixNumberLikeValue(key, String);
        });
    }

    get data(): Data {
        return this.mData;
    }

    public async setData(patch: Partial<Data>): Promise<void> {
        var data: Object = this.restoreJson("data");
        data = { ...data, ...patch };
        try {
            await new Promise((resolve: any, reject: any): any => {
                this.app.sdkHandler.trigger("save", {
                    key: "data",
                    value: JSON.stringify(data),
                    callback: (): any => { }
                });
                resolve();
            });
        } catch (error) {
            console.log("error", error);
        }

        // try {
        //     console.log("user data", patch);
        //     debugger;
        //   //await setUserData(patch as PlainObject);

        // } catch (e) {
        //   console.log(e);
        // }
    }

    public reset(): void {
        this.setData(initialUserData);
    }

    public restoreDate(k: string) {
        var cb: Date | number = 0;
        this.app.sdkHandler.trigger(
            'restore',
            {
                key: k,
                callback: (error, value) => {
                    if (error) {
                        cb = 0;
                    } else {
                        if (value != null && value != '0' && value !== 'NaN') {
                            cb = new Date(value);
                        } else {
                            cb = 0;
                        }
                    }
                },
            },
            this,
        );
        return cb;
    }

    public static JsonToObject(json: string, fallback: Object): Object {
        if (json === null || json === undefined) return fallback;
        var obj: Object = JSON.parse(json);
        if (obj === null || obj === undefined) return fallback;
        return obj;
    }

    public static ValueToString(val: any): Date | number {
        if (val === null || val === undefined || val === "0" || val === 0) return 0;
        var date: number = Date.parse(val);
        if (date === NaN) return 0;
        return new Date(val);
    }

    public static LoadValue(val: Object, fallback: any): any {
        if (val === null || val === undefined || val === "") return fallback;
        return val;
    }

    public restoreJson(k) {
        var cb = 0;
        this.restoreStringifiedJson(k, (error, value) => {
            if (error) {
            } else {
                if (value != null) {
                    cb = JSON.parse(value);
                }
            }
        });
        return cb;
    }

    private restoreStringifiedJson(key, callback) {
        this.app.sdkHandler.trigger('restore', {
            key: key,
            callback: function (error, data) {
                if (error) {
                    callback(error, data);
                } else {
                    var actualData = typeof data === 'object' && data ? data.value : data;
                    callback(error, actualData);
                }
            },
        });
    }
}
